module.exports = __webpack_public_path__ + "img/multiplier_free_10.9ea85319.png";